import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { DepartmentsDTO } from '../types/departments';
import { DepartmentsApiObject } from '../types/departments-response';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsHttpService {
  private http = inject(HttpClient);

  public list$(companyID: number, params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/departments`;
    return this.http.get<DepartmentsApiObject>(url, {
      observe: 'response',
      params,
    });
  }

  public create$(companyID: number, department: DepartmentsDTO) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/departments`;
    return this.http.post<DepartmentsApiObject>(url, department, {
      observe: 'response',
    });
  }

  public get$(companyID: number, departmentID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/departments/${departmentID}`;
    return this.http.get<DepartmentsApiObject>(url, { observe: 'response' });
  }

  public update$(companyID: number, department: DepartmentsDTO) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/departments/${department.departmentId}`;
    return this.http.patch<DepartmentsApiObject>(url, department, {
      observe: 'response',
    });
  }

  public delete$(companyID: number, departmentID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/departments/${departmentID}`;
    return this.http.delete<DepartmentsApiObject>(url, {
      observe: 'response',
    });
  }

  public duplicate$(companyID: number, departmentID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/departments/${departmentID}/duplicates`;
    return this.http.post<DepartmentsApiObject>(
      url,
      {},
      { observe: 'response' }
    );
  }
}
